export const SET_ANNOTATIONS_REACTION = "SET_ANNOTATIONS_REACTION";
export const SET_ANNOTATIONS_MESSAGE = "SET_ANNOTATIONS_MESSAGE";
export const SET_ANNOTATING_MESSAGE = "SET_ANNOTATING_MESSAGE";
